<template>
  <div class="winnerPhone" style="position: relative;">
    <img :src="backgroundImage" class="background-img" />
    <div style="position: absolute; z-index: 9;height: 680px;">
      <img
        src="@/assets/images/starWallpapers/phonetop.png"
        style="width: 100%;"
      />
      <div class="shopLogo">
        <div
          style="width: 26px;height: 26px;background: #ffffff;border-radius: 50%;overflow: hidden;margin-right: 6px;"
        >
          <img
            src="@/assets/images/starWallpapers/shopLogo.png"
            style="width: 100%;height: 100%;"
          />
        </div>
        <span
          style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;max-width: 170px;"
          >{{ shopTitle }}</span
        >
      </div>
      <div v-if="pictureList.length > 0">
        <!-- 手机 -->
        <div class="phone-box" v-show="activeItem.type == 'phone'">
          <img
            src="@/assets/images/starWallpapers/phone-bg.png"
            class="img-frame"
          />
          <div
            :style="{
              backgroundImage: `url(${activeItem.compressedImageUrl})`,
            }"
            class="wallpaper-box"
          ></div>
          <div class="phone-dot"></div>
        </div>
        <!-- ipad -->
        <div class="ipad-box" v-show="activeItem.type == 'ipad'">
          <img
            src="@/assets/images/starWallpapers/ipad-bg.png"
            class="img-frame"
          />
          <div
            :style="{
              backgroundImage: `url(${activeItem.compressedImageUrl})`,
            }"
            class="wallpaper-box"
          ></div>
        </div>
        <!-- 电脑 -->
        <div class="computer-box" v-show="activeItem.type == 'computer'">
          <img
            src="@/assets/images/starWallpapers/computer-bg.png"
            class="img-frame"
          />
          <div
            :style="{
              backgroundImage: `url(${activeItem.compressedImageUrl})`,
            }"
            class="wallpaper-box"
          ></div>
        </div>

        <!-- 底部列表 -->
        <div
          style="width: 100%;position: absolute;bottom: 10px;display: flex;justify-content: center;"
        >
          <div
            class="bottom-paper-list"
            :style="{ 'padding-left': pictureList.length >= 6 ? '20px' : '' }"
          >
            <div
              :class="[
                activeItem.compressedImageUrl == item.compressedImageUrl
                  ? 'list-item-active'
                  : 'list-item',
              ]"
              v-for="(item, index) in pictureList"
              :key="index"
              @click="selectImg(item)"
            >
              <!-- <div
                class="list-item-bg"
                :style="{ backgroundImage: `url(${item.compressedImageUrl})` }"
              ></div> -->
              <el-image
                :src="item.compressedImageUrl"
                class="list-item-bg"
                fit="cover"
                :lazy="true"
              ></el-image>
              <div class="paper-title">
                {{
                  item.type == "phone"
                    ? "手机"
                    : item.type == "ipad"
                    ? "平板"
                    : "电脑"
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="nowinner">
        <img
          src="@/assets/images/starWallpapers/empty.png"
          style="width: 214px;height: 334px;margin-top: 180px;"
        />
        <!-- <span>暂无活动，先去店铺逛逛吧~</span> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    formConfig: {
      typeof: Object,
    },
    winnerList: {
      typeof: Array,
    },
    pictureList: {
      typeof: Array,
    },
  },
  created() {
    // const shopTitle = JSON.parse(sessionStorage.getItem("userInfo")).shopName;
    // this.shopTitle = shopTitle;
    this.shopTitle = "京获客";
  },
  watch: {
    pictureList: {
      handler(val) {
        if (val.length > 0) {
          this.backgroundImage = val[0].compressedImageUrl;
          this.activeItem = val[0];
        } else {
          this.backgroundImage = "";
          this.activeItem = null;
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      shopTitle: "",
      backgroundImage: "",
      activeItem: null,
    };
  },
  methods: {
    selectImg(item) {
      if (!item || this.compressedImageUrl == item.compressedImageUrl) return;
      this.backgroundImage = item.compressedImageUrl;
      this.activeItem = item;
    },
  },
};
</script>
<style lang="scss">
.phone-box {
  position: relative;
  width: 234px;
  margin: 5px auto;
  .img-frame {
    width: 234px;
    height: 483px;
  }
  .wallpaper-box {
    position: absolute;
    left: 8px;
    width: 218px;
    height: 469px;
    top: 7px;
    border-radius: 32px;
    background-size: cover;
    background-position: center;
  }
  .phone-dot {
    background: #000000;
    width: 63px;
    height: 18px;
    position: absolute;
    top: 14px;
    left: 86px;
    border-radius: 50px;
  }
}
.ipad-box {
  position: relative;
  width: 328px;
  margin: 115px auto;
  .img-frame {
    width: 328px;
    height: 251px;
  }
  .wallpaper-box {
    position: absolute;
    left: 10px;
    width: 307px;
    height: 229px;
    top: 11px;
    border-radius: 3px;
    background-size: cover;
    background-position: center;
  }
}
.computer-box {
  position: relative;
  width: 352px;
  margin: 115px auto;
  .img-frame {
    width: 352px;
    height: 276px;
  }
  .wallpaper-box {
    position: absolute;
    left: 4px;
    width: 344px;
    height: 194px;
    top: 4px;
    background-size: cover;
    background-position: center;
  }
}

.download-img {
  width: 50px;
  height: 50px;
  position: absolute;
  bottom: 200px;
  right: 16px;
}

.bottom-paper-list {
  max-width: 100%;
  // position: absolute;
  // bottom: 10px;
  // padding-left: 20px;
  // white-space: nowrap;
  overflow: scroll;
  // 隐藏滚动条
  scrollbar-width: none;
  &::-webkit-scrollbar {
    width: 0 !important;
  }
  -ms-overflow-style: none;
  display: flex;
  flex-wrap: nowrap;
  height: 71px;

  .list-item-active {
    width: 51px;
    height: 68px;
    margin-right: 10px;
    box-shadow: 4px 4px 15px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    border: 1px solid #ffffff;
    position: relative;
  }
  .list-item {
    width: 51px;
    height: 68px;
    margin-right: 10px;
    box-shadow: 4px 4px 15px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    position: relative;
  }
  .list-item-bg {
    border-radius: 6px;
    overflow: hidden;
    width: 49px;
    height: 66px;
    background-size: cover;
    background-position: center;
  }
  .paper-title {
    background: rgba(0, 0, 0, 0.3);
    color: #fff;
    font-size: 10px;
    position: absolute;
    bottom: 0;
    width: 49px;
    padding: 2px;
    text-align: center;
    border-radius: 0 0 6px 6px;
  }
}

.winnerPhone {
  // background-image: url('../../../../assets/images/drawpic/phoneBG.png');
  background-size: 100% auto;
  background-repeat: no-repeat;
  width: 375px;
  height: 680px;
  border-radius: 8px;
  position: relative;
  overflow: auto;
  border: 1px solid #eaeaea;
  &::-webkit-scrollbar {
    display: none; /* 对于 Chrome, Safari 和 Opera 隐藏滚动条 */
  }
  .background-img {
    position: absolute;
    width: 375px;
    height: 680px;
    filter: blur(50px);
  }
  .shopLogo {
    position: absolute;
    display: flex;
    align-items: center;
    top: 55px;
    left: 15px;
  }
  .appTitle {
    width: 100%;
    font-weight: bold;
    font-size: 30px;
    color: #b46e1d;
    text-align: center;
    margin-top: 16px;
  }
  .shopInfo {
    width: calc(100% - 30px);
    margin: 8px 15px;
    background: #ffffff;
    border-radius: 4px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    .InputShop {
      display: flex;
      align-items: center;
      .ShopPic {
        width: 34px;
        height: 34px;
        background: #cccccc;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 8px;
      }
    }
    .goshopbu {
      width: 75px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #000;
      color: #ffffff;
      border-radius: 12px;
      font-weight: 400;
      font-size: 12px;
    }
  }
  .findInput {
    width: calc(100% - 30px);
    margin: 8px 15px;
    background: #ffffff;
    border-radius: 4px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    .pormp {
      font-weight: 400;
      font-size: 12px;
      color: #d7d7d7;
    }
    .findBu {
      width: 46px;
      height: 22px;
      background: linear-gradient(153deg, #ffdfbb 0%, #d19d71 100%);
      border-radius: 4px;
      color: #ffffff;
      font-weight: 400;
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .openidStyle {
    font-weight: 400;
    font-size: 10px;
    color: #925600;
    line-height: 12px;
    text-align: left;
    font-style: normal;
    text-decoration-line: underline;
    text-transform: none;
    margin-left: 15px;
  }
  .winnerTitle {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    background: linear-gradient(
      109.60635264000835deg,
      #b36d1e 0%,
      #b87017 100%
    );
    -webkit-text-fill-color: transparent;
    -webkit-background-clip: text;
    .Licon {
      width: 4px;
      height: 4px;
      background: linear-gradient(200deg, #b36d1e 0%, #b87017 100%);
      border-radius: 1px 1px 1px 1px;
      transform: rotate(45deg);
      margin: 0 7px;
    }
  }
  .winnerList {
    margin-top: 12px;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 15px;
    .winnerGlup {
      width: 100%;
      box-sizing: border-box;
      background: #ffffff;
      padding: 10px 12px;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      border-radius: 4px;
    }
  }
  .nowinner {
    width: 100%;
    height: 350px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 12px;
    color: #815117;
  }
}
</style>
